import { useState } from 'react';
import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { classNames } from '@/utils/classNames';

import Icon from '@/components/base/Icon';
import { Pill } from '@/components/base/Pill';

type SparksFABProps = {
    onClick: () => void;
};

export function SparksFAB({ onClick }: SparksFABProps) {
    const { t } = useTranslation('sparks');
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            type="button"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={classNames(
                'flex items-center justify-center gap-3 overflow-hidden',
                'rounded-[18px] border border-icoGray-300 bg-white shadow-icoXS',
                'transition-all duration-500 ease-in-out',
                isHovered ? 'h-[60px] px-4' : 'size-[60px]'
            )}>
            <Image
                src="/images/svg/sparks-avatar.svg"
                alt="Sparks"
                width={34}
                height={34}
                className="shrink-0"
            />
            {isHovered && (
                <div className="flex shrink-0 flex-col items-baseline gap-1.5">
                    <div className="flex items-center gap-1">
                        <span className="whitespace-nowrap font-GBold text-[10px] uppercase leading-3 tracking-wide text-icoGray-500">
                            {t('hi_sparks')}
                        </span>
                        <Pill variant="warning">{t('beta')}</Pill>
                    </div>
                    <span className="whitespace-nowrap font-GSemiBold text-xs tracking-tight text-icoBlack">
                        {t('how_can_i_help')}
                    </span>
                </div>
            )}
            {isHovered && (
                <Icon icon="chevron-right" className="shrink-0 text-[14px] text-icoGray-500" />
            )}
        </button>
    );
}
